import styled from 'styled-components';
import { palette } from 'styled-tools';

import { fontSize, FontSizes, fontWeight, FontWeights, minWidth } from '@calm-web/design-system';

export const Wrapper = styled.section`
	padding: 100px 0 0;
`;

export const Grid = styled.div`
	margin: 0 auto;
	max-width: calc(100% - 40px);

	${minWidth('tablet')} {
		display: grid;
		grid-gap: 36px;
		grid-template-columns: 2fr 2fr;
	}

	${minWidth('desktop')} {
		grid-template-columns: 2fr 2fr 2fr;
		max-width: 960px;
	}
`;

export const HowToUseTitle = styled.h2`
	color: ${palette('gray7')};
	${fontSize(FontSizes['2xl'])};
	font-weight: 100;
	grid-column: 1 / 3;
	margin-bottom: 55px;
	text-align: center;

	${minWidth('desktop')} {
		grid-column: 1 / 4;
	}
`;

export const HowToUseSubtitle = styled.div`
	max-width: 640px;
	${fontWeight(FontWeights.Light)};
	display: block;
	margin-bottom: 3.5rem;

	${minWidth('desktop')} {
		margin-bottom: 2rem;
	}
`;

export const TileContainer = styled.div`
	width: 100%;
	display: flex;
	justify-content: space-around;
	flex-wrap: wrap;
	max-width: 66rem;
	margin: 0 auto;
`;

export const TileWrapper = styled.div`
	border-radius: 10px;
	height: 340px;
	margin: 0 auto 36px;
	position: relative;
	text-align: center;
	width: 296px;

	${minWidth('tablet')} {
		margin-bottom: 0;
	}
`;

export const TileImage = styled.img`
	display: flex;
	border-radius: 10px;
	width: 100%;
	height: 100%;
	position: absolute;
	left: 0;
	top: 0;
	z-index: -1;
`;

export const TextWrapper = styled.div`
	color: ${palette('white')};
	padding: 100px 30px 40px;
	text-align: center;
	z-index: 1;
`;

export const TileTitle = styled.div`
	font-size: 24px;
	${fontWeight(FontWeights.Medium)};
	line-height: 1.5;
	margin-bottom: 22px;
`;

export const TileSubtitle = styled.div`
	font-size: 18px;
	${fontWeight(FontWeights.Light)};
	line-height: 1.5;
`;
